import { useEffect, useState } from 'react';
import './Navbar.css';

const menuItems = [
  { title: 'Home', href: '#home', links: [] },
  {
    title: 'About',
    href: '#about',
    links: [
      // { label: 'Our Story', href: '#about' }, { label: 'Doctors', href: '#about' }
    ],
  },
  // {
  //   title: 'Treatments',
  //   href: '#treatments',
  //   links: [
     
  //   ],
  // },
  { title: 'Success Stories', href: '#stories', links: [] },
  { title: 'Contact', href: '#contact', links: [] },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setShowScrollTop(offset > 300);
      setScrolled(offset > 20);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={`navbar-wrapper ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className={`top-bar ${scrolled ? 'top-bar-collapsed' : ''}`}>
        <div className="contact-info">
          <a href="tel:+919779848111">
            <span aria-hidden="true">📞</span> +91 97798 48111
          </a>
          <a href="mailto:ivfankur@gmail.com">
            <span aria-hidden="true">✉️</span> ANKUR IVF FEROZEPUR CITY
          </a>
          
        </div>
        <div className="top-bar-actions">
          <div className="brand-name">ANKURIVF</div>
        </div>
      </div>

      <div className="main-nav">
        <div className="brand-logo">
          <img
            src="/images/ivfLogo.png"
            alt="ANKUR IVF logo"
            style={{ height: '48px', width: 'auto', objectFit: 'contain' }}
          />
        </div>

        <button
          type="button"
          className="menu-toggle"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav-links ${menuOpen ? 'open' : ''}`} aria-label="Primary navigation">
          {menuItems.map((item) => (
            <div className="nav-item" key={item.title}>
              <a href={item.href} onClick={closeMenu}>
                {item.title}
              </a>
              {item.links.length > 0 && (
                <div className="submenu">
                  {item.links.map((link) => (
                    <a key={link.label} href={link.href} onClick={closeMenu}>
                      {link.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>

      <a
        className="phone-float"
        href="tel:+919779848111"
        aria-label="Call us"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M6.6 10.8c1.2 2.4 3.1 4.3 5.5 5.5l1.8-1.8a1 1 0 0 1 1-.2c1.1.4 2.3.6 3.5.6a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.8 21 3 13.2 3 4a1 1 0 0 1 1-1h3.6a1 1 0 0 1 1 1c0 1.2.2 2.4.6 3.5a1 1 0 0 1-.2 1l-1.8 1.8Z"
            fill="currentColor" 
          />
        </svg>
      </a>

      <a
        className="whatsapp-float"
        href="https://wa.me/919779848111?text=Hello%20AnkurIVF%20I%20would%20like%20to%20know%20more%20about%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp" 
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.966-.273-.099-.471-.149-.67.149-.198.297-.768.966-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.149-.174.199-.297.299-.495.099-.198.05-.372-.025-.521-.074-.149-.669-1.612-.916-2.208-.241-.579-.486-.501-.669-.51l-.57-.01c-.198 0-.521.074-.793.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.174-1.413-.074-.124-.273-.198-.57-.347z"
            fill="currentColor"
          />
          <path
            d="M20.52 3.45A11.94 11.94 0 0 0 12 .5C6.14.5 1.5 5.14 1.5 11.01c0 1.94.51 3.84 1.48 5.5L.5 23.5l6.98-1.84a11.94 11.94 0 0 0 5.72 1.38c5.86 0 10.5-4.64 10.5-10.5 0-2.8-1.09-5.44-3.08-7.43Zm-8.52 18.02c-1.8 0-3.57-.48-5.11-1.39l-.37-.22-4.14 1.09 1.1-4.03-.24-.39A9.95 9.95 0 0 1 2.5 11.01C2.5 6.27 6.78 2 11.52 2c2.43 0 4.72.95 6.44 2.67 1.72 1.72 2.68 4.01 2.68 6.44 0 4.74-4.28 9.02-9.02 9.02Z"
            fill="currentColor"
          />
        </svg>
      </a>
      
      {showScrollTop && (
        <button type="button" className="scroll-top-btn" onClick={scrollToTop} aria-label="Go to top">
          ↑
        </button>
      )}
    </div>
  );
}

export default Navbar;
